<div class="bg-gray-200 px-6 py-2 text-sm font-bold text-gray-900">
  <h3><slot /></h3>
</div>
